import { useQuery } from '@tanstack/react-query';

import { fetchData } from 'src/app/queries';

import { metrcKeys } from './query-key-factory';

type DeliveryTransactions = {
  id: number;
  TransactionAction: string | null;
};

export type METRCConfigResponse = {
  AllowPostingToFinishedPackages: boolean;
  AllowUntrackedInventorySales: boolean;
  APIKey: string | null;
  AutoCreateProducts: boolean;
  BaseUrl: string | null;
  BatchMode: boolean;
  BatchModeMaxAttempts: number;
  BatchModeTimeoutSeconds: number;
  CaptureReceiptIDs: boolean;
  CheckForOnHoldInventory: boolean;
  CheckForOversell: boolean;
  ClientApiKey: string | null;
  CompareInventoryRooms: boolean;
  CreateDeliveryOnCheckout: boolean;
  CreatePackageDonationTradeSampleOption: boolean;
  CreateReceiptOnReturn: boolean;
  DefaultHttpClientTimeout: number;
  DefaultMetrcLabsInReceive: boolean;
  DeliveryTransactionAction: number;
  DeliveryTransactions: DeliveryTransactions[];
  Emails: string[];
  EnableAllotmentCheck: boolean;
  EnableBatchModeEmails: boolean;
  EnableDeliveryTransactions: boolean;
  EnableMetrcFinishing: boolean;
  EnableNewMdAllotmentCheck: boolean;
  EnableOnboarding: boolean;
  EnableReturns: boolean;
  EnableUntrackedInventoryTransfers: boolean;
  EnableUpdatePatients: boolean;
  ExemptCustomerTypes: unknown[];
  ExpirationDateFieldId: number;
  IgnoreAdjustments: boolean;
  IgnoreReceiptSavingFailures: boolean;
  IgnoreSales: boolean;
  IsEnabled: boolean;
  IsItemMaintainer: boolean;
  IsRoomMaintainer: boolean;
  IsStrainMaintainer: boolean;
  License: string | null;
  LocId: number;
  LogsInTelemetry: boolean;
  LspId: number;
  NewDeliveryEndpoint: boolean;
  NewPatientStatusEndpoint: number;
  NewReceiptEndpoint: boolean;
  PlantReportedWeightBatchSize: number;
  PreventMetrcPackageLocationMoves: boolean;
  RateLimitInMs: number | null;
  ReportProductThcOnReceipt: boolean;
  RequireUserAPIKey: boolean;
  SalesBatchModeOnTimeout: boolean;
  SalesReportingType: number;
  SendPackageWholesalePriceInManifest: number;
  StateCode: string | null;
  SyncPlantCacheOn: number;
  TrackReceiptsByTimestamp: boolean;
  TreatMoistureLossAsHarvestWaste: boolean;
  UseBatchLabData: boolean;
  UseExternalId: boolean;
  UseMetrcLabData: boolean;
  UseMetrcRetailId: boolean;
  UseMetrcV2: boolean;
  UseProductionBatch: boolean;
  UseRelativeAdjustments: boolean;
  UserKeysForVoids: boolean;
  UseTransferTemplates: boolean;
};

export function useMETRCConfigQuery(enabled) {
  return useQuery({
    enabled,
    queryKey: metrcKeys.config(),
    queryFn: () => fetchData<METRCConfigResponse>('api/metrc/get-settings'),
  });
}

// re-export to match other integration setting query naming conventions
export const useMetrcSettingsQuery = useMETRCConfigQuery;
